import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpMainHeaderComponent from './adpMainHeader.component';

let adpMainHeaderModule = angular.module('adpMainHeader', [
  uiRouter
])

.component('adpMainHeader', adpMainHeaderComponent)

.name;

export default adpMainHeaderModule;



// WEBPACK FOOTER //
// ./src/app/components/adpMainHeader/adpMainHeader.js